var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("detect-network", {
        on: { "detected-condition": _vm.handleConnectivityChange }
      }),
      _vm._v(" "),
      _c("detect-version"),
      _vm._v(" "),
      _vm.$store.state.app.section == "login" ? [_c("router-view")] : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "home" ? [_c("router-view")] : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "app"
        ? [
            _c("header-view"),
            _vm._v(" "),
            _c("sidebar-view"),
            _vm._v(" "),
            _c("router-view"),
            _vm._v(" "),
            _c("BaseModalPackage")
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "pos" ? [_c("router-view")] : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "error" ? [_c("router-view")] : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "admin" ? [_c("router-view")] : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.section == "callback"
        ? [_c("router-view")]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 